import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Logo from "components/Brand/Logo";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function BrandColumn() {
  return (
    <MKBox
      flex={1}
      minWidth={260}
      width={{ xs: "100%", md: "auto" }}
      display="flex"
      flexDirection="column"
      alignItems={{ xs: "center", md: "flex-start" }}
      textAlign={{ xs: "center", md: "left" }}
    >
      {/* 🔹 Logo */}
      <Logo height={50} />

      {/* 🔹 Social Media Icons */}
      <MKBox display="flex" mt={2} gap={1}>
        {/* <a href="https://facebook.com" target="_blank" rel="noreferrer">
          <FacebookIcon sx={{ color: "#3b5998", fontSize: 28, cursor: "pointer" }} />
        </a> */}
        {/* <a href="https://twitter.com" target="_blank" rel="noreferrer">
          <TwitterIcon sx={{ color: "#1DA1F2", fontSize: 28, cursor: "pointer" }} />
        </a> */}
        <a href="https://linkedin.com" target="_blank" rel="noreferrer">
          <LinkedInIcon sx={{ color: "#0077b5", fontSize: 28, cursor: "pointer" }} />
        </a>
      </MKBox>

      {/* 🔹 Email */}
      <MKBox mt={2} display="flex" alignItems="center" gap={1}>
        <EmailIcon fontSize="small" />
        <a href="mailto:example@email.com" style={{ textDecoration: "none", color: "inherit" }}>
          <MKTypography variant="body2" sx={{ cursor: "pointer" }}>
            info@matrix180.co.uk
          </MKTypography>
        </a>
      </MKBox>

      {/* 🔹 Phone */}
      <MKBox mt={1} display="flex" alignItems="center" gap={1}>
        <PhoneIcon fontSize="small" />
        <a href="tel:+447498467748" style={{ textDecoration: "none", color: "inherit" }}>
          <MKTypography variant="body2" sx={{ cursor: "pointer" }}>
            (+44)7498 4677 48
          </MKTypography>
        </a>
      </MKBox>
      {/* 🔹 WhatsApp */}
      <MKBox mt={1} display="flex" alignItems="center" gap={1}>
        <WhatsAppIcon sx={{ fontSize: 20, color: "#25D366" }} />
        <a
          href="https://wa.me/447498467748"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <MKTypography variant="body2" sx={{ cursor: "pointer" }}>
            Chat on WhatsApp
          </MKTypography>
        </a>
      </MKBox>

      {/*  Address (links to Google Maps) */}
      <MKBox mt={1} display="flex" alignItems="flex-start" gap={1}>
        <LocationOnIcon fontSize="small" />
        <a
          href="https://www.google.com"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <MKTypography variant="body2" sx={{ cursor: "pointer" }}>
            Nottingham, United Kingdom
          </MKTypography>
        </a>
      </MKBox>
    </MKBox>
  );
}
